<template>
  <div class="uk-container">
    404
  </div>
</template>

<script>
export default {
  name: 'ViewErrorRouteNotFound'
}
</script>
